<template>
    <div id="print-message">
        <div v-if="message" style="padding: 6mm;">
            <link href="/css/print.css" rel="stylesheet" type="text/css">

            <header class="border-bottom" style="height: 20mm;">
                <div class="logo" style="float: left;">
                    <img :src="`${ $store.getters.webservice_url }/storage/logo.png`" style="height: 20mm; width: auto;" alt=""/>
                </div>
                <div class="viewer-display-name" style="float: right;">
                    <span style="line-height: 20mm; font-weight: bold; font-size: 12pt; color: #444;">{{ displayNameOfCurrentViewer }}</span>
                </div>
            </header>
            <section class="border-bottom">
                <h3>{{ message.subject }}</h3>
                <span>{{ amountMessages }} bericht {{ amountMessages !== 1 ? 'en' : '' }}</span>
            </section>
            <section class="ncrypt-message border-bottom" v-for="(messageItem, i) in messages" :key="`${i}-${messageItem.id}`"
                     style="border-color: #eee; width: 100%; float: left;">
                <div class="message-header" style="width: 100%; float: left;">
                    <div style="float: left;">
                        <span class="sender">{{ messageItem.sender.display_name }}</span><br/>
                        <span class="receiver">Aan: {{ messageItem.recipients.map(e => e.email).join(",") }}</span>
                    </div>
                    <div style="float: right;">
                        {{ messageItem.sent_at }}
                    </div>
                </div>
                <div class="message-body" style="width: 100%; float: left; padding: 5mm 3mm 2mm;">
                    <span v-if="messageItem.is_retracted" class="retracted">Dit bericht is teruggetrokken door de afzender</span>
                    <span v-else v-html="messageItem.body"></span>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: "PrintMessage",
        props: {
            message: {type: Object},
            recipientViewer: {type: Object},
        },
        computed: {
            displayNameOfCurrentViewer() {
                if (this.$store.getters.authed) {
                    return this.$store.getters.user.display_name;
                }

                if (this.recipientViewer) {
                    return this.recipientViewer.display_name;
                }

                return '';
            },
            amountMessages() {
                if (!this.message) {
                    return 0;
                }

                if (!this.message.history) {
                    return 1;
                }

                return this.message.history.length + 1;
            },
            messages() {
                if (!this.message) {
                    return [];
                }

                return [this.message].concat(this.message.history);
            }
        },
        mounted() {
            document.title = `${this.$store.getters.app_name} bericht - ${this.message.subject}`;

            this.$nextTick(() => {
                this.$htmlToPaper('print-message', null, () => {
                    this.$emit('done');
                });
            });
        },
    }
</script>
